export default function leadReport() {
	return {
		onCall: null,
		leadsCount: null,
		leadsCountChart: null,
		leadsGrowthRate: null,
		confirmedLeads: null,
		confirmedCountChart: null,
		confirmedGrowthRate: null,
		wrongNumbers: null,
		unsuccessfulLeads: null,
		unconfirmedLeads: null,
		topLeads: [],
		topProductsTotals: null,
		topProductsNames: null,
		lowestLeads: [],
		averageTimePerSale: null,
		fromDate: '',
        toDate: '',
        confirmed_leads: [],
        created_leads: [],
        filteredLeads: [],
        filteredConfirmed: [],

		gridLineColor: 'rgba(77, 138, 240, .1)',
	    primary:         "#727cf5",
	    secondary:       "#7987a1",
	    success:         "#42b72a",
	    info:            "#68afff",
	    warning:         "#fbbc06",
	    danger:          "#ff3366",
	    light:           "#ececec",
	    dark:            "#282f3a",
	    muted:           "#686868",

		init() {
            this.loadLeads();
        },
		loadLeads() {
            axios.get(`/api/reports/leads?fromDate=` + fromDate + '&toDate=' + toDate).then(response => {
            	this.onCall = response.data.onCall;
            	this.leadsCount = response.data.leadsCount;
            	this.leadsCountChart = response.data.leadsCountChart;
            	this.leadsGrowthRate = response.data.leadsGrowthRate;
            	this.confirmedLeads = response.data.confirmedLeads;
            	this.onCall = response.data.onCall;
            	this.confirmedCountChart = response.data.confirmedCountChart;
            	this.confirmedGrowthRate = response.data.confirmedGrowthRate;
            	this.wrongNumbers = response.data.wrongNumbers;
            	this.unsuccessfulLeads = response.data.unsuccessfulLeads;
            	this.unconfirmedLeads = response.data.unconfirmedLeads;
            	this.topLeads = response.data.topLeads;
            	this.topProductsTotals = response.data.topProductsTotals;
            	this.topProductsNames = response.data.topProductsNames;
            	this.lowestLeads = response.data.lowestLeads;
            	this.averageTimePerSale = response.data.averageTimePerSale;
            	this.created_leads = response.data.created_leads.map(lead => {
                    let date = new Date(lead.created_at);

                    return {
                        ...lead,
                        created_at: lead.created_at = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                    };
                });

                this.confirmed_leads = response.data.confirmed_leads.map(lead => {
                    let date = new Date(lead.confirmed_at);

                    return {
                        ...lead,
                        confirmed_at: lead.confirmed_at = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
                    };
                });

                this.applyFilter('created_leads', this.created_leads, (leads) => {
                    this.filteredLeads = leads;
                });
                this.applyFilter('confirmed_leads', this.confirmed_leads, (confirmed) => {
                    this.filteredConfirmed = confirmed;
                });
            	this.drawCharts();
            });
        },
        labelize(data, labels) {
            let withLabel = {};
            for (var i = 0; i <= labels.length; i++) {
                withLabel[labels[i]] = data[labels[i]] ? data[labels[i]] : 0;
            }
            return withLabel;
        },
        drawCharts() {
		    var monthlyLeadsChart = document.getElementById('monthly-leads-chart').getContext('2d');
		    new Chart(monthlyLeadsChart, {
		        type: 'bar',
		        data: {
		          labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
		          datasets: [{
		            label: 'Leads',
		            data: Object.values(this.leadsCountChart),
		            backgroundColor: this.primary
		          }]
		        },
		        options: {
		          maintainAspectRatio: false,
		          legend: {
		            display: false,
		              labels: {
		                display: false
		              }
		          },
		          scales: {
		            xAxes: [{
		              display: true,
		              barPercentage: .3,
		              categoryPercentage: .6,
		              gridLines: {
		                display: false
		              },
		              ticks: {
		                fontColor: '#8392a5',
		                fontSize: 10
		              }
		            }],
		            yAxes: [{
		              gridLines: {
		                color: this.gridLineColor
		              },
		              ticks: {
		                fontColor: '#8392a5',
		                fontSize: 10,
		                min: 0,
		              }
		            }]
		          }
		        }
		      }
		    );

		    if($('#monthly-confirmed-chart').length) {
			    var monthlyConfirmedChart = document.getElementById('monthly-confirmed-chart').getContext('2d');
			    new Chart(monthlyConfirmedChart, {
			        type: 'bar',
			        data: {
			          labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
			          datasets: [{
			            label: 'Sales',
			            data: Object.values(this.confirmedCountChart),
			            backgroundColor: this.primary
			          }]
			        },
			        options: {
			          maintainAspectRatio: false,
			          legend: {
			            display: false,
			              labels: {
			                display: false
			              }
			          },
			          scales: {
			            xAxes: [{
			              display: true,
			              barPercentage: .3,
			              categoryPercentage: .6,
			              gridLines: {
			                display: false
			              },
			              ticks: {
			                fontColor: '#8392a5',
			                fontSize: 10
			              }
			            }],
			            yAxes: [{
			              gridLines: {
			                color: this.gridLineColor
			              },
			              ticks: {
			                fontColor: '#8392a5',
			                fontSize: 10,
			                min: 0,
			              }
			            }]
			          }
			        }
			      }
			    );
		  	}
		  	if($('#chartjsPie').length) {
			    new Chart($('#chartjsPie'), {
			      type: 'pie',
			      data: {
			        labels: [this.topProductsNames],
			        datasets: [{
			          label: "Per Product Sales",
			          backgroundColor: ["#7ee5e5","#f77eb9","#4d8af0"],
			          data: [this.topProductsTotals]
			        }]
			      }
			    });
			}

            var ctx = document.getElementById('leads-vs-confirm').getContext('2d');

            const labels = this.generateChartLabels();
            if (window.chart) {window.chart.destroy();}
            window.chart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'New Leads',
                        data: Object.values(this.labelize(this.filteredLeads, labels)),
                        backgroundColor: ['rgba(0, 0, 0, 0)'],
                        borderColor: ['rgba(114, 124, 245, 1)'],
                        borderWidth: 2
                    }, {
                        label: 'Confirmed Leads',
                        data: Object.values(this.labelize(this.filteredConfirmed, labels)),
                        backgroundColor: ['rgba(0, 0, 0, 0)'],
                        borderColor: ['#f57281'],
                        borderWidth: 2
                    }]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });
        },
        countfyObject(object) {
            for (var key of Object.keys(object)) {
                object[key] = object[key].length;
            }
            return object;
        },
        groupByDate(type, data) {
        	if(type == 'created_leads') {
            	return _.groupBy(data, "created_at");
            }else {
            	return _.groupBy(data, "confirmed_at");
            }
        },
        applyFilter(type, data, callback) {

            data = this.applyDateFilter(data);
            data = this.groupByDate(type, data);
            data = this.countfyObject(data);
            callback(data);
        },
        applyDateFilter(data) {
            return data.filter(item => {
                return moment(item.created_at).isBetween(fromDate, toDate, null, '()') ||
                    moment(item.created_at, "DD-MM-YYYY").isSame(moment(fromDate, "DD-MM-YYYY")) ||
                    moment(item.created_at, "DD-MM-YYYY").isSame(moment(toDate, "DD-MM-YYYY")) ||
                    moment(item.confirmed_at).isBetween(fromDate, toDate, null, '()') ||
                    moment(item.confirmed_at, "DD-MM-YYYY").isSame(moment(fromDate, "DD-MM-YYYY")) ||
                    moment(item.confirmed_at, "DD-MM-YYYY").isSame(moment(toDate, "DD-MM-YYYY"));
            });
        },
        generateChartLabels() {
            const from = fromDate;
            const to = toDate;

            const daysDiff = ((new Date(to).getTime()) - (new Date(from).getTime())) / (1000 * 3600 * 24);

            return getDatesBetween((new Date(from)), (new Date(to))).map(date => {
                return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            });
        },
        filterDate($event) {
        	this.loadLeads();
        }
	}
}

function getDatesBetween(fromDate, toDate) {
    var dates = [],
    currentDate = fromDate;
    toDate = new Date(toDate);
    toDate.setDate(toDate.getDate() + 1);

    addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    };
    while (currentDate <= toDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
    }

    return dates;
};
